module.exports = __webpack_public_path__ + "static/media/zce.4aa0e05c.png";